import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const questions = [
  {
    question: "What is AnamVR?",
    answer:
      "AnamVR is a mental wellness platform that uses virtual reality and cognitive behavioural therapy techniques to support your mental health.",
  },
  {
    question: "How do I download or install AnamVR?",
    answer:
      "You can download AnamVR from the App Store or Google Play. Visit our Download page for direct links.",
  },
  {
    question: "How does AnamVR work?",
    answer:
      "AnamVR offers immersive VR experiences and guided exercises designed by mental health professionals to help you relax, focus, and improve your wellbeing.",
  },
  {
    question: "Is AnamVR free? What's the pricing?",
    answer:
      "AnamVR offers both free and premium plans. You can try the basic features for free, or upgrade for more content and features.",
  },
  {
    question: "What devices are supported?",
    answer:
      "AnamVR works with most VR headsets and is compatible with iPhone and Android smartphones (4.7–7.2 inch displays).",
  },
  {
    question: "Can I use AnamVR without a headset?",
    answer:
      "Some features can be accessed without a VR headset, but for the best experience, we recommend using a compatible headset.",
  },
  {
    question: "What's included in Premium?",
    answer:
      "Premium includes access to exclusive VR experiences, advanced tracking, and personalised wellness plans.",
  },
  {
    question: "How do I contact support?",
    answer:
      "You can contact our support team through the Contact page or by emailing support@anamvr.com.",
  },
  {
    question: "Is my data private and secure?",
    answer:
      "Yes, your privacy is important to us. We never share your personal data without your consent.",
  },
  {
    question: "Who created AnamVR?",
    answer:
      "AnamVR was created by a team of mental health professionals and technologists passionate about improving wellbeing through technology.",
  },
];

export default function Questions() {
  const [activeIndex, setActiveIndex] = useState<number | undefined>();
  const animation = useScrollAnimation({ delay: 100 });

  function handleToggle(index: number) {
    if (activeIndex === index) {
      setActiveIndex(undefined);
    } else {
      setActiveIndex(index);
    }
  }

  return (
    <>
      <div
        ref={animation.ref}
        className={`max-w-7xl my-16 mx-auto px-4 pt-12 pb-24 transition-opacity duration-700 ease-out ${
          animation.isVisible ? "animate-slide-up" : "opacity-0"
        }`}
      >
        <div className="text-center text-purple-900 mb-16 flex flex-col items-center">
          <span className="font-semibold text-5xl">FAQs</span>
        </div>

        <div className="flex flex-col gap-6 px-4 sm:px-6 md:px-12 lg:px-24 xl:px-48">
          {questions.map((item, index) => (
            <div
              key={index}
              className={`pb-6 ${
                index === 0 ? "border-t border-[#545454]/30 pt-6 " : ""
              }${
                index !== questions.length - 1
                  ? "border-b border-[#545454]/30"
                  : ""
              } cursor-pointer`}
              onClick={() => handleToggle(index)}
            >
              <h3 className="md:text-2xl sm:text-xl text-lg flex items-center justify-between font-medium text-black">
                {item.question}
                {activeIndex === index ? (
                  <Minus size={20} className="text-lg text-gray-700" />
                ) : (
                  <Plus size={20} className="text-lg text-gray-700" />
                )}
              </h3>
              {activeIndex === index && (
                <p className="mt-4 text-base sm:text-lg text-gray-700">
                  {item.answer}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Have more questions button */}
        <div className="mt-16 flex justify-center">
          <a href="/contact" aria-label="Contact us for more questions">
            <button className="px-8 py-3 bg-[#7745b8] hover:bg-[#6a3ba6] text-white rounded-full font-semibold transition-colors flex items-center gap-2">
              Have more questions?
            </button>
          </a>
        </div>
      </div>
    </>
  );
}
